module.exports = __webpack_public_path__ + "static/media/wabenzy-logo.16f5db56.png";